import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
export default function Modal({ title, onClose, children, wide }) {
  const ref = useRef(null);
  const closeRef = useRef(onClose); closeRef.current=onClose;
  useEffect(() => {
    const previous = document.activeElement;
    const controls = () => [...ref.current.querySelectorAll('button,input,textarea,select,a[href],[tabindex="0"]')].filter(el=>!el.matches(':disabled')&&el.getAttribute('aria-hidden')!=='true');
    (controls().find(el=>el.matches('input,textarea,select'))||controls()[0])?.focus();
    const handle = e => {
      if (e.key === 'Escape') closeRef.current();
      if (e.key === 'Tab') { const list = controls(), first = list[0], last = list[list.length - 1]; if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last?.focus(); } else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); } }
    };
    document.addEventListener('keydown', handle);
    return () => { document.removeEventListener('keydown', handle); previous?.focus(); };
  }, []);
  return <div className="modal-backdrop" onMouseDown={e => e.target === e.currentTarget && onClose()}><section ref={ref} className={`modal ${wide ? 'modal-wide' : ''}`} role="dialog" aria-modal="true" aria-labelledby="dialog-title"><button className="modal-close icon-button" aria-label="Close dialog" onClick={onClose}><X size={20}/></button><h2 id="dialog-title">{title}</h2>{children}</section></div>;
}
